import { useState } from 'react'
import { Form, Modal } from 'react-bootstrap';
import PaymentReceipt from '../PaymentReceipt';

const GenerateReceipt = ({ showReceipt, onHide, payment, address }) => {
  const [tinNumber, setTinNumber] = useState("");
  const [checked, setChecked] = useState({
    kinya: true,
    english: false,
  });
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showReceipt}
      >
        <Modal.Header closeButton onClick={onHide}>
          <h5>Generate Receipt</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <div className='d-flex justify-content-center mb-4'>
            <Form.Check
              type='radio'
              id='kinya'
              label='Kinyarwanda'
              name='language'
              checked={checked.kinya}
              onChange={() =>
                setChecked({
                  kinya: true,
                })
              }
            />
            <div>
              <Form.Check
                type='radio'
                label='English'
                id='english'
                className='ml-2'
                name='language'
                checked={checked.english}
                onChange={() =>
                  setChecked({
                    english: true,
                  })
                }
              />
            </div>
          </div>
          <div className='d-flex justify-content-center mt-2'>
            <PaymentReceipt
              language={checked}
              address={
                address.length === 0
                  ? JSON.parse(localStorage.getItem("locations"))
                  : address
              }
              date={payment?.datetime}
              tin={tinNumber}
              accountId={payment?.accountId}
              amount={payment?.amount}
              onHide={onHide}
              tid={payment?.transactionId}
              resetTin={setTinNumber}
              title='Generate payment receipt'
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default GenerateReceipt